import React from "react";
import { useLocation } from "react-router-dom";

const SocialLinks: React.FC = () => {
  const location = useLocation();

  // ✅ Mostra social SOLO nella homepage
  const isHomePage = location.pathname === "/";

  if (!isHomePage) {
    return null;
  }

  return (
    <div style={{ margin: "20px", textAlign: "center", clear: "both" }}>
      <p style={{ marginBottom: "10px", fontWeight: "bold", color: "#333" }}>
        Seguici sui social:
      </p>
      <ul
        style={{
          listStyle: "none",
          padding: 0,
          display: "flex",
          justifyContent: "center",
          gap: "20px",
          flexWrap: "wrap",
          margin: 0,
        }}
      >
        <li>
          <a
            href="https://www.instagram.com/ai.trekking.finder"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Seguici su Instagram"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              padding: "10px 20px",
              background: "#e1306c",
              color: "white",
              textDecoration: "none",
              borderRadius: "8px",
              fontWeight: 500,
              minWidth: "44px",
              minHeight: "44px",
            }}
          >
            <i className="fab fa-instagram"></i>
            <span>Instagram</span>
          </a>
        </li>
        <li>
          <a
            href="https://www.facebook.com/aitrekkingfinder"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Seguici su Facebook"
            style={{
              display: "inline-flex",
              alignItems: "center",
              gap: "8px",
              padding: "10px 20px",
              background: "#1877f2",
              color: "white",
              textDecoration: "none",
              borderRadius: "8px",
              fontWeight: 500,
              minWidth: "44px",
              minHeight: "44px",
            }}
          >
            <i className="fab fa-facebook-f"></i>
            <span>Facebook</span>
          </a>
        </li>
      </ul>
    </div>
  );
};

export default SocialLinks;
